/**
 * LanguageTool — AI Grammar Checker & Paraphraser
 *
 * Sets <html data-lt-installed="true">. Like Grammarly's data-gr-ext-installed, this
 * is not an incidental side effect — it is an explicit installation flag written where
 * any script can read it. It also injects <lt-*> custom elements for its toolbar.
 *
 * Observed on version 11.0.0.
 */
import { probeRootAttribute, probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'oldceeleldhonbafppcapldpdifcinji';
export const languagetool: ExtensionDefinition = {
  id: ID,
  name: 'AI Grammar Checker & Paraphraser – LanguageTool',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2_000_000,
  notes:
    'Second extension found writing a literal "installed" flag into the page ' +
    '(data-lt-installed), after Grammarly\'s data-gr-ext-installed.',
  signals: [
    { id: 'dom-html-lt-installed', kind: 'dom',
      description: 'Check <html data-lt-installed> — an explicit installation flag readable by any script.',
      weight: 1, run: () => probeRootAttribute('data-lt-installed') },
    { id: 'dom-lt-toolbar', kind: 'dom',
      description: 'Look for its <lt-toolbar> / <lt-div> custom elements, which carry the vendor prefix in the tag name.',
      weight: 1, run: () => probeSelector('lt-toolbar, lt-div, lt-span', { timeoutMs: 1500 }) },
  ],
};
